import HttpClient from "../../../../libs/utils/httpClient";
import { Logger } from "../../../../libs/utils/logger";
import { getCustomerUrl } from "../../../../libs/utils/utils";

/**
 * API methods to interact with customer and location-related endpoints.
 */
const httpClient = HttpClient.getClient();
/**
 * Get the active customer record.
 */
export const getCustomerData = async () => {
  try {
    return await httpClient.get(getCustomerUrl('', false));
  } catch (err) {
    Logger.error('Failed to fetch customer data', err);
    return null;
  }
};
/**
 * Get list of active location entries for a customer.
 */
export const getLocationDetailData = async () => {
  try {
    const listRequest = {
      pageNumber: 1,
      pageSize: 25,
      sortOptions: { sortBy: 'id', sortOrder: 'asc' },
      criteria: {
        filters: [{ operator: 'eq', key: 'status', values: ['ACTIVE'] }],
      },
    };
    return await httpClient.post(getCustomerUrl('location/list', false), listRequest);
  } catch (err) {
    Logger.error('Failed to fetch location details', err);
    return [];
  }
};